import { render, staticRenderFns } from "./BreedingRhombusSpinner.vue?vue&type=template&id=7c827517&scoped=true&"
import script from "./BreedingRhombusSpinner.vue?vue&type=script&lang=js&"
export * from "./BreedingRhombusSpinner.vue?vue&type=script&lang=js&"
import style0 from "./BreedingRhombusSpinner.vue?vue&type=style&index=0&id=7c827517&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c827517",
  null
  
)

export default component.exports